/**
 * Status płatności
 *
 * @export
 * @enum {number}
 */
export enum PaymentState {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  CONTRACTOR_FAILURE = 'CONTRACTOR_FAILURE',
  FAILURE = 'FAILURE',
  NOT_ATTACHED = 'NOT_ATTACHED',
  NOT_SENT = 'NOT_SENT',
  UNCONFIRMED = 'UNCONFIRMED',
  KO_SENT = 'KO_SENT',
  LIST_SENT = 'LIST_SENT',
  PAID = 'PAID',
  RECEIVED_FUNDS = 'RECEIVED_FUNDS'
}

/**
 * Kolory na liście odpowiadające statusom
 *
 * @export
 * @enum {number}
 */
export enum PaymentStateColors {
  CANCELED = 'table-secondary',
  CONFIRMED = '',
  CONTRACTOR_FAILURE = 'table-danger',
  FAILURE = 'table-danger',
  NOT_ATTACHED = 'table-warning',
  NOT_SENT = '',
  UNCONFIRMED = '',
  KO_SENT = '',
  LIST_SENT = '',
  PAID = '',
  RECEIVED_FUNDS = ''
}

/**
 * Tłumaczenia statusów
 *
 * @export
 * @enum {number}
 */
export enum PaymentStateTranslations {
  CANCELED = 'Anulowany',
  CONFIRMED = 'Zatwierdzone',
  CONTRACTOR_FAILURE = 'Niepowodzenie tworzenia kontrahenta',
  FAILURE = 'Niepowodzenie tworzenia zobowiązania',
  NOT_ATTACHED = 'Niepowodzenie dołączania do paczki',
  NOT_SENT = 'W trakcie przygotowania',
  UNCONFIRMED = 'Odtwierdzona',
  KO_SENT = 'Wniosek wysłany',
  LIST_SENT = 'Lista do BK wysłana',
  PAID = 'Środki wypłacone przez BK',
  RECEIVED_FUNDS = 'Środki otrzymane'
}
